import { createAsyncThunk } from '@reduxjs/toolkit';
import { validateAirport } from '@/libs/validation/validateAirport';
import { FlightField } from './interface';
import { flightsActions } from './index';
export const setFlightTo = createAsyncThunk('flights/setFlightTo', async ({ _uuid, value, code }, thunkApi) => {
    const isValueInList = Boolean(code);
    const { error } = await validateAirport(value, { isValueInList });
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.to,
        value,
    }));
    thunkApi.dispatch(flightsActions._setFlightCode({
        _uuid,
        field: 'toCode',
        code,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.to,
        error,
    }));
});
